export const LOGIN_REDIRECT = "/login-redirect";
